export const sidenavbarActionTypes = {
    'SET_SIDE_BAR':"SET_SIDE_BAR",
    'SET_SIDE_BAR_CLOSE':'SET_SIDE_BAR_CLOSE'
}